/**
 * Transform a list of error DTOs into a mapping of field names to
 * error message lists.
 *
 * @param {Array<{field: string, message: string}>} errors
 * @param {string} fallbackKey row-level fallback key (usually ID)
 * @returns {Object<string, Array<string>>}
 */
const mapTapValidationErrors = (errors, fallbackKey) =>
  errors.reduce((accumulator, tapValidationError) => {
    const message = tapValidationError?.message;
    const field = tapValidationError?.field;

    // If the error has a specific field, then we map
    // the message to that field. Otherwise, we map it
    // to the fallback key.
    const key = field ?? fallbackKey;

    if (!accumulator.hasOwnProperty(key)) {
      accumulator[key] = [];
    }
    accumulator[key].push(message);
    return accumulator;
  }, {});

export default mapTapValidationErrors;
